import { base64ToStr } from '@payfit/growth-platform-brand-system-v2';
import { DATA_QCD } from './getObsufcatdAttributes';

export const findHeadersLinkByUrlWithoutParams = (
  url: string,
  links: HTMLElement[],
): HTMLElement | undefined => {
  let targetUrlPath: string;

  try {
    const parsedUrl = new URL(url, window.location.origin);
    targetUrlPath = parsedUrl.origin + parsedUrl.pathname;
  } catch {
    return undefined; // URL is invalid
  }

  return links.find((elt) => {
    let href = elt.getAttribute('href');
    if (!href) return false;

    if (!['http://', 'https://', '#', '/'].some((x) => href?.startsWith(x)))
      return false;

    const qcd = elt.getAttribute(DATA_QCD);
    if (qcd) {
      const hrefDecoded = base64ToStr(qcd);
      const parsedHref = new URL(hrefDecoded, window.location.origin);
      href = parsedHref.origin + parsedHref.pathname;
    }

    try {
      const linkUrl = new URL(href, window.location.origin);
      const linkPath = linkUrl.origin + linkUrl.pathname;

      return linkPath === targetUrlPath;
    } catch {
      return false;
    }
  });
};
